/* Vytalnest — thème « Aube » : interactions (sans dépendance). */
(() => {
  'use strict';

  const vn = (window.vn = window.vn || {});
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const routes = vn.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  const strings = vn.strings || {};
  const root = routes.root.endsWith('/') ? routes.root : routes.root + '/';

  /* ---------------------------------------------------------------- money */
  function formatMoney(cents, format) {
    const value = Math.round(Number(cents) || 0);
    const fmt = format || vn.moneyFormat || '{{amount_with_comma_separator}} €';
    const num = (n, decimals, thousands, sep) => {
      const fixed = (n / 100).toFixed(decimals);
      const parts = fixed.split('.');
      const int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? int + sep + parts[1] : int;
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return num(value, 2, ',', '.');
        case 'amount_no_decimals': return num(value, 0, ',', '.');
        case 'amount_with_comma_separator': return num(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(value, 0, '.', ',');
        case 'amount_with_space_separator': return num(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return num(value, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return num(value, 2, "'", '.');
        default: return num(value, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }
  vn.formatMoney = formatMoney;

  /* ----------------------------------------------------------------- cart */
  const SECTION_ID = 'vn-cart-drawer';

  async function postJSON(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    });
    let data = {};
    try { data = await res.json(); } catch (e) { /* empty */ }
    if (!res.ok || data.status) {
      const err = new Error(data.description || data.message || strings.error || 'Erreur');
      err.data = data;
      throw err;
    }
    return data;
  }

  const Cart = {
    async add(items) {
      const data = await postJSON(routes.cartAdd + '.js', { items, sections: SECTION_ID, sections_url: window.location.pathname });
      Drawer.render(data.sections && data.sections[SECTION_ID]);
      return data;
    },
    async change(line, quantity) {
      const data = await postJSON(routes.cartChange + '.js', { line, quantity, sections: SECTION_ID, sections_url: window.location.pathname });
      Drawer.render(data.sections && data.sections[SECTION_ID]);
      updateCount(data.item_count);
      return data;
    },
    async refresh() {
      const res = await fetch(`${root}?sections=${SECTION_ID}`);
      const data = await res.json();
      Drawer.render(data[SECTION_ID]);
    },
  };
  vn.cart = Cart;

  function updateCount(count) {
    if (typeof count !== 'number') return;
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
    $$('[data-vn-cart-open]').forEach((el) => el.setAttribute('aria-label', count ? `Panier, ${count} article${count > 1 ? 's' : ''}` : 'Panier'));
  }

  /* --------------------------------------------------------------- drawer */
  const Drawer = {
    el: null,
    lastFocus: null,
    init() {
      this.el = $('[data-vn-drawer]');
      if (!this.el) return;
      document.addEventListener('click', (e) => {
        const open = e.target.closest('[data-vn-cart-open]');
        if (open) { e.preventDefault(); this.open(open); return; }
        if (e.target.closest('[data-vn-cart-close]') && this.isOpen()) {
          const link = e.target.closest('a[href]');
          this.close();
          if (link && link.getAttribute('href').includes('#')) {
            /* let the anchor scroll happen */
          } else if (link) {
            return;
          }
          if (!link) e.preventDefault();
        }
      });
      document.addEventListener('keydown', (e) => {
        if (!this.isOpen()) return;
        if (e.key === 'Escape') { this.close(); return; }
        if (e.key === 'Tab') this.trap(e);
      });
      this.bindBody();
      const count = Number($('#vn-cart-drawer-body', this.el)?.dataset.cartCountValue);
      if (!Number.isNaN(count)) updateCount(count);
    },
    isOpen() { return this.el && !this.el.hidden; },
    open(trigger) {
      if (!this.el) { window.location.href = routes.cart; return; }
      this.lastFocus = trigger || document.activeElement;
      this.el.hidden = false;
      document.documentElement.classList.add('vn-locked');
      requestAnimationFrame(() => {
        this.el.classList.add('is-open');
        $('.vn-drawer__panel', this.el).focus({ preventScroll: true });
      });
    },
    close() {
      if (!this.isOpen()) return;
      this.el.classList.remove('is-open');
      document.documentElement.classList.remove('vn-locked');
      const done = () => { this.el.hidden = true; };
      if (reduceMotion) done(); else setTimeout(done, 380);
      if (this.lastFocus && document.contains(this.lastFocus)) this.lastFocus.focus({ preventScroll: true });
    },
    trap(e) {
      const focusables = $$('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', this.el)
        .filter((n) => n.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === $('.vn-drawer__panel', this.el))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    },
    render(html) {
      if (!html || !this.el) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById('vn-cart-drawer-body');
      const body = $('#vn-cart-drawer-body', this.el);
      if (fresh && body) {
        body.innerHTML = fresh.innerHTML;
        body.dataset.cartCountValue = fresh.dataset.cartCountValue;
        updateCount(Number(fresh.dataset.cartCountValue));
      }
      const page = $('[data-vn-cart-page]');
      if (page && fresh) page.innerHTML = fresh.innerHTML.replace(/vn-cart--drawer/g, 'vn-cart--page');
    },
    busy(on) { $$('#vn-cart-drawer-body, [data-vn-cart-page]').forEach((b) => b.classList.toggle('is-busy', on)); },
    error(msg) {
      $$('#vn-cart-drawer-body, [data-vn-cart-page]').forEach((b) => {
        let el = $('.vn-cart__error', b);
        if (!el) { el = document.createElement('p'); el.className = 'vn-cart__error'; el.setAttribute('role', 'alert'); b.prepend(el); }
        el.textContent = msg || strings.error || 'Erreur';
        clearTimeout(el._t);
        el._t = setTimeout(() => el.remove(), 5000);
      });
    },
    bindBody() {
      document.addEventListener('click', async (e) => {
        const qtyBtn = e.target.closest('[data-vn-qty]');
        const upsell = e.target.closest('[data-vn-upsell]');
        if (!qtyBtn && !upsell) return;
        if (!e.target.closest('[data-vn-cart-contents]')) return;
        e.preventDefault();
        this.busy(true);
        try {
          if (qtyBtn) await Cart.change(Number(qtyBtn.dataset.line), Math.max(0, Number(qtyBtn.dataset.vnQty)));
          else await Cart.add([{ id: Number(upsell.dataset.vnUpsell), quantity: 1 }]);
        } catch (err) {
          this.error(err.message);
        } finally {
          this.busy(false);
        }
      });
      document.addEventListener('change', async (e) => {
        const input = e.target.closest('.vn-qty__input');
        if (!input || !e.target.closest('[data-vn-cart-contents]')) return;
        this.busy(true);
        try { await Cart.change(Number(input.dataset.line), Math.max(0, parseInt(input.value, 10) || 0)); }
        catch (err) { this.error(err.message); }
        finally { this.busy(false); }
      });
    },
  };

  /* -------------------------------------------------------- buy box (lots) */
  function initBuy(section) {
    const buy = $('[data-vn-buy]', section);
    const form = $('[data-vn-buy-form]', section) || $('form', buy || section);
    if (!buy || !form) return;
    const bundlesOn = buy.dataset.bundles === 'true';
    const addBtn = $('[data-vn-add]', form);
    const addLabel = $('[data-vn-add-label]', form);
    const totalEl = $('[data-vn-total]', form);
    const errorEl = $('[data-vn-error]', form);
    const sticky = $('[data-vn-sticky]', section);
    const stickyLabel = $('[data-vn-sticky-label]', section);
    const gallery = $('[data-vn-gallery]', section);

    const selectedBundle = () => {
      const r = $('input[name="quantity"]:checked', form) || $('input[name="quantity"]', form);
      return r && r.type === 'radio' ? r : null;
    };
    const count = () => (bundlesOn && selectedBundle() ? Number(selectedBundle().value) : 1);

    function syncClasses() {
      $$('.vn-bundle', form).forEach((l) => l.classList.toggle('is-checked', !!$('input:checked', l)));
      $$('.vn-swatch', form).forEach((l) => l.classList.toggle('is-checked', !!$('input:checked', l)));
    }

    function update() {
      const n = count();
      const picks = $$('[data-pick]', form);
      picks.forEach((fs) => {
        const i = Number(fs.dataset.pick);
        fs.hidden = i > n;
        const label = $('[data-pick-label]', fs);
        if (label) label.textContent = n > 1 ? `Bracelet ${i}` : 'Couleur';
        const checked = $('input:checked', fs);
        const name = $('[data-pick-name]', fs);
        if (name && checked) name.textContent = checked.dataset.color || '';
      });
      const b = selectedBundle();
      const total = b ? Number(b.dataset.total) : Number(buy.dataset.unit);
      if (totalEl) totalEl.textContent = formatMoney(total);
      if (stickyLabel) stickyLabel.textContent = (n > 1 && b ? `${b.dataset.label} · ` : '') + formatMoney(total);
      syncClasses();
    }

    // when a bundle grows, pre-fill new pickers with the first picker's colour (or the next available one)
    function prefill() {
      const first = $('[data-pick="1"] input:checked', form);
      if (!first) return;
      $$('[data-pick]', form).forEach((fs) => {
        if (fs.dataset.pick === '1' || $('input:checked', fs)) return;
        const same = $(`input[value="${first.value}"]:not([disabled])`, fs) || $('input:not([disabled])', fs);
        if (same) same.checked = true;
      });
    }
    prefill();

    form.addEventListener('change', (e) => {
      if (e.target.name === 'quantity') prefill();
      if (e.target.closest('[data-pick="1"]') && e.target.dataset.media && gallery) gallery.dispatchEvent(new CustomEvent('vn:goto-media', { detail: e.target.dataset.media }));
      update();
    });
    update();

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      const n = count();
      const ids = [];
      const picks = $$('[data-pick]', form);
      if (picks.length) {
        for (let i = 1; i <= n; i++) {
          const fs = picks.find((p) => Number(p.dataset.pick) === i);
          const checked = fs && $('input:checked', fs);
          if (checked) ids.push(Number(checked.value));
        }
      } else {
        const idInput = $('input[name="id"]', form);
        for (let i = 0; i < n; i++) ids.push(Number(idInput.value));
      }
      const tally = new Map();
      ids.forEach((id) => tally.set(id, (tally.get(id) || 0) + 1));
      const items = Array.from(tally, ([id, quantity]) => ({ id, quantity }));
      if (!items.length) return;

      addBtn.classList.add('is-loading');
      addBtn.setAttribute('aria-busy', 'true');
      const prev = addLabel ? addLabel.textContent : '';
      if (addLabel) addLabel.textContent = strings.adding || 'Ajout…';
      try {
        await Cart.add(items);
        Drawer.open(addBtn);
      } catch (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
      } finally {
        addBtn.classList.remove('is-loading');
        addBtn.removeAttribute('aria-busy');
        if (addLabel) addLabel.textContent = prev;
      }
    });

    // sticky bar: visible once the hero is gone and while the buy box is off screen
    if (sticky && 'IntersectionObserver' in window) {
      const hero = $('[data-vn-hero]');
      let pastHero = !hero;
      let buyVisible = false;
      let buyAbove = false;
      let footerVisible = false;
      const setSticky = () => {
        const on = (pastHero || buyAbove) && !buyVisible && !footerVisible;
        sticky.classList.toggle('is-visible', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        const btn = $('[data-vn-sticky-btn]', sticky);
        if (btn) btn.tabIndex = on ? 0 : -1;
      };
      if (hero) {
        new IntersectionObserver(([en]) => { pastHero = !en.isIntersecting && en.boundingClientRect.top < 0; setSticky(); }, { threshold: 0 }).observe(hero);
      }
      new IntersectionObserver(([en]) => {
        buyVisible = en.isIntersecting;
        buyAbove = !en.isIntersecting && en.boundingClientRect.top < 0;
        setSticky();
      }, { threshold: 0.15 }).observe(buy);
      const footer = $('.vn-footer');
      if (footer) new IntersectionObserver(([en]) => { footerVisible = en.isIntersecting; setSticky(); }, { threshold: 0 }).observe(footer);
    }
  }

  /* --------------------------------------------------------------- gallery */
  function initGallery(gallery) {
    const track = $('[data-vn-track]', gallery);
    if (!track) return;
    const slides = $$('.vn-gallery__slide', track);
    const prev = $('[data-vn-prev]', gallery);
    const next = $('[data-vn-next]', gallery);
    const thumbs = $$('[data-vn-thumb]', gallery);
    const indexEl = $('[data-vn-index]', gallery);
    let current = 0;

    const goTo = (i, smooth = true) => {
      const idx = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
    };
    const strip = $('[data-vn-thumbs]', gallery);
    const setCurrent = (i) => {
      current = i;
      if (indexEl) indexEl.textContent = String(i + 1);
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      thumbs.forEach((t, k) => {
        if (k === i) {
          t.setAttribute('aria-current', 'true');
          // scroll the thumbnail strip only (never the page)
          if (strip && strip.scrollWidth > strip.clientWidth) {
            strip.scrollTo({ left: t.offsetLeft - strip.offsetLeft - strip.clientWidth / 2 + t.clientWidth / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
          }
        } else t.removeAttribute('aria-current');
      });
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting && en.intersectionRatio > 0.6) setCurrent(slides.indexOf(en.target)); });
      }, { root: track, threshold: [0.6] });
      slides.forEach((s) => io.observe(s));
    }
    prev && prev.addEventListener('click', () => goTo(current - 1));
    next && next.addEventListener('click', () => goTo(current + 1));
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.vnThumb))));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });
    gallery.addEventListener('vn:goto-media', (e) => {
      const i = slides.findIndex((s) => s.dataset.mediaId === String(e.detail));
      if (i >= 0) goTo(i);
    });
    setCurrent(0);
  }

  /* ------------------------------------------------- dawn + header tone */
  function initScrollScenes() {
    const header = $('[data-vn-header]');
    const dawn = $('[data-vn-dawn]');
    if (dawn && reduceMotion) dawn.classList.add('is-static');

    let ticking = false;

    const onScroll = () => {
      ticking = false;
      const vh = window.innerHeight;
      if (dawn && !reduceMotion) {
        const r = dawn.getBoundingClientRect();
        const span = Math.max(1, r.height - vh);
        const p = Math.min(1, Math.max(0, -r.top / span));
        // ease so the light arrives softly
        const eased = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        dawn.style.setProperty('--p', eased.toFixed(4));
        dawn.dataset.tone = eased > 0.5 ? 'day' : 'night';
      }
      if (header) {
        const y = Math.max(0, header.getBoundingClientRect().bottom) + 2;
        const el = document.elementFromPoint(Math.min(40, window.innerWidth / 2), y);
        const zone = el && el.closest('[data-tone]:not([data-vn-header])');
        const tone = zone ? zone.dataset.tone : 'day';
        if (header.dataset.tone !== tone) header.dataset.tone = tone;
        const meta = $('meta[name="theme-color"]');
        if (meta) meta.setAttribute('content', tone === 'night' ? '#000000' : '#ffffff');
      }
    };
    const request = () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } };
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    onScroll();
  }

  /* ---------------------------------------------------------------- reveal */
  function initReveal() {
    const items = $$('[data-reveal]');
    if (!items.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) { items.forEach((i) => i.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach((i) => io.observe(i));
  }

  /* -------------------------------------------------------------- hero 3D */
  function webglOK() {
    try {
      const c = document.createElement('canvas');
      return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl')));
    } catch (e) { return false; }
  }
  function initHero() {
    const stage = $('[data-vn-stage]');
    if (!stage) return;
    const saveData = navigator.connection && navigator.connection.saveData;
    const vibrateOnce = () => {
      stage.classList.remove('is-vibrating');
      void stage.offsetWidth;
      stage.classList.add('is-vibrating');
    };
    stage.addEventListener('vn:vibrate', vibrateOnce);
    const fallback = () => { setTimeout(vibrateOnce, 1500); };
    if (reduceMotion || saveData || stage.hasAttribute('data-no-3d') || !webglOK() || !vn.assets || !vn.assets.hero3d) { fallback(); return; }
    const start = () => {
      import(new URL(vn.assets.hero3d, document.baseURI).href)
        .then((m) => m.init(stage))
        .catch(() => fallback());
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (entries.some((en) => en.isIntersecting)) { io.disconnect(); start(); }
      });
      io.observe(stage);
    } else start();
  }

  /* ------------------------------------------------------------------ boot */
  function boot() {
    Drawer.init();
    $$('[data-vn-product]').forEach(initBuy);
    $$('[data-vn-gallery]').forEach(initGallery);
    initScrollScenes();
    initReveal();
    initHero();
    // theme editor: re-run the scripts of a section that was just re-rendered
    document.addEventListener('shopify:section:load', (e) => {
      const s = e.target;
      $$('[data-vn-product]', s).forEach(initBuy);
      $$('[data-vn-gallery]', s).forEach(initGallery);
      if ($('[data-vn-stage]', s)) initHero();
      if ($('[data-vn-drawer]', s)) Drawer.init();
      initReveal();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();